import * as React from 'react';
import { SharePoolModel, Operations, OfferingStatus, OfferingViewModel } from 'Core/Api/Api';
import Table, { ColumnProps } from 'antd/lib/table';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import ShowIfHavePermission from 'components/Forms/ShowIfHavePermission';
import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';
import NumberFormat from 'react-number-format';
import IfNotLoggedInModal from 'components/Forms/IfNotLoggedInModal';
import { Typography } from 'antd';
import { BrandedButton } from '../../../Styled/Branded/BrandedButton';

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
    sharePool?: SharePoolModel[];
    offering?: OfferingViewModel;
    currency?: string;
    offeringStatus?: OfferingStatus;
}

export interface State { }

export default class SharepoolDetailsTable extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    generalApplyClicked(offeringId, sharePoolId) {
        this.props.history.push(
            `/ipo/apply/${offeringId}?sp=${sharePoolId}`,
            new DetailsData(DetailsMode.New, offeringId)
        );

    };

    sharePoolTableColumns: Array<ColumnProps<SharePoolModel>> = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Price',
            render: (text: any, record: SharePoolModel, index: number) => {
                return (
                    <NumberFormat
                        value={record.price}
                        displayType={'text'}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={'$'}
                        renderText={value => (
                            <div>
                                {value} {this.props.currency}
                            </div>
                        )}
                    />
                );
            },
        },
        {
            title: 'Allocation',
            render: (text: any, record: SharePoolModel, index: number) => {
                return (
                    <NumberFormat value={record.allocation} displayType={'text'} thousandSeparator={true} />
                );
            },
        },
        {
            render: (text: any, record: SharePoolModel, index: number) => {
                return (
                    (this.props.offeringStatus == OfferingStatus.PreOpen || this.props.offeringStatus == OfferingStatus.Opened) ?
                        <IfNotLoggedInModal offeringId={record.offeringId} sharepoolId={record.id}>
                            <BrandedButton onClick={e => this.generalApplyClicked(record.offeringId, record.id)}>
                                <span>Apply Now</span>
                            </BrandedButton>
                        </IfNotLoggedInModal>
                        : null);
            },
        },
    ];

    render() {
        return (
            <Table<SharePoolModel>
                title={x => (
                    <Typography.Title style={{ fontWeight: 'bolder', color: 'black' }} level={4} type="secondary">
                        {this.props.offering?.sharePoolCategoryName ?? 'Sharepools'}
                    </Typography.Title>
                )}
                pagination={false}
                columns={this.sharePoolTableColumns}
                dataSource={this.props.sharePool}
            />
        );
    }
}
